import { $ as isHostnameContainsCC } from './index-e29b327a.js';
import { V as buildUrlPathnameFromArray } from './analytics-b6a65ffa.js';

/**
 * This function generates a correct URL path name for PES resources.
 * It also covers the special case for China.
 * Example given the following input parameters:
 * ```json
 * {
 *  origin: "localhost"
 *  path: "product/HOM115"
 *  isPublic: false
 *  languageCode: "en"
 *  countryCode: "US"
 * }
 * ```
 *  - *Result*: `'http://localhost/US/en/v3/product/HOM115'`
 */
const getBaseNavigationUrl = ({ origin, path, isPublic, languageCode, countryCode, }) => {
    const countryCodePath = isPublic ? countryCode === null || countryCode === void 0 ? void 0 : countryCode.toLowerCase() : countryCode;
    const pathnameArray = [];
    if (!isHostnameContainsCC())
        pathnameArray.push(countryCodePath);
    pathnameArray.push(languageCode);
    if (!isPublic)
        pathnameArray.push('v3');
    if (path.length)
        pathnameArray.push(path);
    const urlPathname = buildUrlPathnameFromArray(pathnameArray);
    return origin ? new URL(urlPathname, origin).href : urlPathname;
};

export { getBaseNavigationUrl as g };
